import { useMemo, useState } from 'react';

import CustomIcon from '@components/utils/CustomIcon';
import { CloseIcon, PersonIcon } from '@assets/icons';
import { Row, SimpleButton } from '@components/formStyles';
import { useCommonState } from '@components/views/reservation-information/contexts/common';
import { GuestInformations } from '@components/views/reservation-information/contexts/common/types';

import {
  GuestButton,
  SavedGuestsContainer,
  SavedGuestText,
} from './savedGuestsStyle';

export const isDataSame = <D,>(currentData: D, itemId?: string) => {
  const savedData = (
    JSON.parse(localStorage.getItem('guests') ?? '[]') as { itemId: string }[]
  ).filter((x) => x.itemId === itemId);
  return JSON.stringify(currentData) === JSON.stringify(savedData);
};

export const isValidGuestForSave = (item: Omit<GuestInformations, 'id'>) =>
  item?.firstname &&
  item?.lastname &&
  item?.gender &&
  item?.birthdate &&
  item?.birthdate?.length === 10;

const SavedGuests = ({
  handleAssignGuest,
  copiedGuestIds = [],
  onCopiedGuestsChange,
  handleRemoveAssignedGuest,
}: {
  handleAssignGuest: (guest: GuestInformations) => void;
  copiedGuestIds?: string[];
  onCopiedGuestsChange?: (copiedGuests: string[]) => void;
  handleRemoveAssignedGuest?: () => void;
}) => {
  const { guests } = useCommonState();
  const [selectedGuestId, setSelectedGuestId] = useState<string>();

  const _handleAssignGuest = (guest: GuestInformations) => {
    const nextCopiedGuestIds = copiedGuestIds.filter(
      (copiedId) => copiedId !== guest.id && copiedId !== selectedGuestId
    );
    nextCopiedGuestIds.push(guest.id);
    setSelectedGuestId(guest.id);
    handleAssignGuest(guest);
    onCopiedGuestsChange?.(nextCopiedGuestIds);
  };

  const filteredGuestList = useMemo(() => {
    return guests.filter(
      (guest) =>
        !copiedGuestIds.includes(guest.id) || guest.id === selectedGuestId
    );
  }, [copiedGuestIds, guests, selectedGuestId]);
  return filteredGuestList.length ? (
    <SavedGuestsContainer>
      {filteredGuestList?.map((guest) => (
        <GuestButton
          key={guest.id}
          style={{ borderRadius: 30 }}
          outline
          onClick={() => {
            _handleAssignGuest(guest);
          }}
        >
          <SavedGuestText>
            {guest.firstname} {guest.lastname}
          </SavedGuestText>
          {guest.id === selectedGuestId ? (
            <Row>
              <span style={{ marginRight: 5 }}>Eklendi</span>
              <SimpleButton
                type='button'
                onClick={(event) => {
                  event.stopPropagation();
                  onCopiedGuestsChange?.(
                    copiedGuestIds.filter((id) => id !== guest.id)
                  );
                  setSelectedGuestId(undefined);
                  handleRemoveAssignedGuest?.();
                }}
              >
                <CustomIcon
                  icon={CloseIcon}
                  fontSize={12}
                  paletteColor='matterHorn'
                />
              </SimpleButton>
            </Row>
          ) : (
            <Row>
              <span style={{ marginRight: 5 }}>Forma Ekle</span>
              <CustomIcon
                icon={PersonIcon}
                fontSize={12}
                paletteColor='matterHorn'
              />
            </Row>
          )}
        </GuestButton>
      ))}
    </SavedGuestsContainer>
  ) : null;
};

export default SavedGuests;
